import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

const featureType = FeatureType.SIGN_UP_INCENTIVE;

export const signIncentivePopupAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		UpdatePopupState: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg.body) {
					queryParams.append(key, arg.body[key]);
				}
				return {
					url: `/rest/${featureType}/tracker/${
						arg.popupType
					}?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: () => [{ type: "featureTrackerTag", id: featureType }]
		})
	})
});

export const { useUpdatePopupStateMutation } = signIncentivePopupAPI;
